let ENV = "prod"; // 环境变量
// 定义API地址
const opDevAPI = "https://op-api.yt.starmerx.com";
const opProdAPI = "https://analytics.garvee.com";
// const opProdAPI = "https://op.starmerx.com";
const brandAPI = "https://brandservice.test.starmerx.com";
const opAPI = ENV === "dev" ? opDevAPI : opProdAPI;
const adminAPI = ENV === "dev" ? "https://garvee-admin.nt.starmerx.com" : "https://admin-api.garvee.com";
// Garvee 自建后端 API（抽奖转盘等活动接口）
const BACKEND_API_URL = ENV === "dev" ? "https://garvee-backend-test-547493248390.us-east4.run.app" : "https://api.garvee.com";
// 店铺 ID（lottery / order_tracking 等接口共用的 X-Shop-ID）
const SHOP_ID = "019cade1-169b-763b-b695-a80e4f40947a";
// 抽奖活动 Campaign ID
const LOTTERY_CAMPAIGN_ID = "019f17a2-2902-7423-b545-b17e0fa27110";

// 封装fetch请求函数
async function fetchRequest(method, url, data = null, headers = {}) {
  const options = {
    method: method,
    headers: {
      ...headers,
    },
  };

  if (data) {
    // 判断data是否包含File或文件数组
    const hasFile = Object.values(data).some((value) => {
      if (value instanceof File) return true;
      if (Array.isArray(value) && value.some((item) => item instanceof File))
        return true;
      return false;
    });

    if (hasFile) {
      // 处理文件上传
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // 如果是数组，逐个append
          value.forEach((item) => {
            if (item instanceof File || typeof item !== "object" || item === null) {
              formData.append(key, item);
            } else {
              formData.append(key, JSON.stringify(item));
            }
          });
        } else if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === "object" && value !== null) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });
      options.body = formData;
    } else {
      // 普通数据，使用 JSON
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(data);
    }
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`Network error: ${response.status} ${response.statusText}`);
  }
  return await response.json();
}

// 生成符合UUID v4标准的函数（利用crypto API）
function generateUUID() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // 版本号4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // 变体
  const hexBytes = Array.from(bytes).map((b) =>
    b.toString(16).padStart(2, "0")
  );
  return (
    hexBytes.slice(0, 4).join("") +
    "-" +
    hexBytes.slice(4, 6).join("") +
    "-" +
    hexBytes.slice(6, 8).join("") +
    "-" +
    hexBytes.slice(8, 10).join("") +
    "-" +
    hexBytes.slice(10, 16).join("")
  );
}

// 获取本地存储的匿名ID，若无则生成并保存
function getOrCreateAnonymousId() {
  const STORAGE_KEY = "garvee_anonymous_id";
  let anonymousId = localStorage.getItem(STORAGE_KEY);
  if (!anonymousId) {
    anonymousId = generateUUID();
    localStorage.setItem(STORAGE_KEY, anonymousId);
  }
  return anonymousId;
}

// 使用 navigator.sendBeacon 发送行为日志
function sendBehaviorLog(data = {}) {
  const urlParams = new URLSearchParams(window.location.search);
  data.domain = window.location.href;
  data.utm_source = urlParams.get('utm_source') || '';
  data.utm_medium = urlParams.get('utm_medium') || '';
  data.utm_id = urlParams.get('utm_id') || '';

  // 确保 data.request_json 中包含用户 ID
  if (data.request_json) {
    data.request_json.user_id = getOrCreateAnonymousId();
  } else {
    data.request_json = {
      user_id: getOrCreateAnonymousId(),
    };
  }
  // 将整个 data 对象转换为 JSON 字符串
  const jsonData = JSON.stringify(data);
  // 创建 Blob 对象，设置 MIME 类型为 application/json
  const blob = new Blob([jsonData], { type: "application/json" });
  // 构造目标 URL
  const url = `${opAPI}/knowledge/garvee_log/save_log/`;
  // 使用 navigator.sendBeacon 发送请求
  const success = navigator.sendBeacon(url, blob);
  // 返回布尔值表示请求是否被成功排队

  // 第二路上报：复制新对象，追加tid，不改动baseData
  const data2 = { ...data, tid: "G-TQ8F7PNDJ6" ,event_name:"garvee_log_event"};
  const blob2 = new Blob([JSON.stringify(data2)], { type: "application/json" });
  const url2 = `https://metrics.garvee.com/knowledge/garvee_log/save_log/`;
  const success2 = navigator.sendBeacon(url2, blob2);

  return success;
}

// 提交延保表单
function subWarrantyForm(data) {
  const urlParams = new URLSearchParams(window.location.search);
  data.source_info = {
    domain: window.location.href,
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_id: urlParams.get('utm_id') || ''
  };

  return fetchRequest(
    "POST",
    `${opAPI}/complaint/brand_warranty_extension/save_brand_warranty_extension/`,
    data
  );
}

// 提交空调安装表单
function subAcInstallForm(data) {
  return fetchRequest(
    "POST",
    `${opAPI}/complaint/ac_order/create_ac_order/`,
    data
  );
}

// 获取订单物流追踪信息
function getOrderTrackingInfo(params) {
  const queryParams = new URLSearchParams({ ...params, update_oms_events: 'false' }).toString();
  return fetchRequest(
    "POST",
    `${adminAPI}/api/v1/order_tracking/get_order_info/?${queryParams}`,
    null,
    { "x-shop-id": SHOP_ID }
  );
}

// ==========================================
// 抽奖转盘（Lottery）接口封装
// 接口文档：LOTTERY_FRONTEND_INTEGRATION.md
// 所有接口需携带 Header: X-Shop-ID
// 响应统一格式：{ code: 0, msg: "success", data: {...} }
// ==========================================

// 活动预览（标题、时间范围、奖品列表、是否需要表单）
// GET /lottery/campaign/{campaign_id}/preview
function lotteryPreview() {
  return fetchRequest(
    "GET",
    `${BACKEND_API_URL}/api/v1/lottery/campaign/${LOTTERY_CAMPAIGN_ID}/preview`,
    null,
    { "x-shop-id": SHOP_ID }
  );
}

// 邮箱下单校验（填表单前调用，校验该邮箱是否在店铺下过单）
// POST /lottery/campaign/{campaign_id}/check-email
function lotteryCheckEmail(email) {
  return fetchRequest(
    "POST",
    `${BACKEND_API_URL}/api/v1/lottery/campaign/${LOTTERY_CAMPAIGN_ID}/check-email`,
    { email },
    { "x-shop-id": SHOP_ID }
  );
}

// 提交问卷表单（复用通用表单接口）
// POST /forms/submit?code={code}
// payload: 表单数据对象；contactInfo: 联系人邮箱，用于后续校验和状态还原
function submitSurveyForm(code, payload, contactInfo) {
  return fetchRequest(
    "POST",
    `${BACKEND_API_URL}/api/v1/forms/submit?code=${code}`,
    { payload, contact_info: contactInfo },
    { "x-shop-id": SHOP_ID }
  );
}

// 查询表单提交记录（复用通用表单接口）
// GET /forms/submissions?code={code}&contact_info={contactInfo}
// code: 表单编码（如 survey_test）；contactInfo: 联系人邮箱
// 返回 { code, msg, data: { items: [...], total, page, page_size } }
function getFormSubmissions(code, contactInfo) {
  const params = new URLSearchParams({
    code: code,
    contact_info: contactInfo,
  });
  return fetchRequest(
    "GET",
    `${BACKEND_API_URL}/api/v1/forms/submissions?${params.toString()}`,
    null,
    { "x-shop-id": SHOP_ID }
  );
}

// 执行抽奖（内置完整校验：时间范围 / Shopify 客户身份 / 表单提交 / 频率规则）
// POST /lottery/campaign/{campaign_id}/draw
// userId: 用户标识（邮箱）
function lotteryDraw(userId) {
  return fetchRequest(
    "POST",
    `${BACKEND_API_URL}/api/v1/lottery/campaign/${LOTTERY_CAMPAIGN_ID}/draw`,
    { user_id: userId },
    { "x-shop-id": SHOP_ID }
  );
}